import { ValidityPeriod } from '@app/pcs/models';
import { Action } from '@ngrx/store';

interface FetchCalendarPayload {
  calendarId: number;
  validityPeriod: ValidityPeriod;
}

export enum CalendarActionTypes {
  FetchCalendar = '[Calendar] Fetch Calendar',
  FetchCalendarFail = '[Calendar] Fetch Calendar Fail'
}

export class FetchCalendar implements Action {
  readonly type = CalendarActionTypes.FetchCalendar;
  constructor(public payload: FetchCalendarPayload) {
  }
}

export class FetchCalendarFail implements Action {
  readonly type = CalendarActionTypes.FetchCalendarFail;
  constructor(public payload: Error) {
  }
}

export type CalendarActions =
  | FetchCalendar
  | FetchCalendarFail;
